var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipFillPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.47071L5.77223 10.1985C5.19304 10.7777 4.40749 11.103 3.5884 11.103C2.76931 11.103 1.98376 10.7777 1.40457 10.1985C0.825384 9.61929 0.5 8.83374 0.5 8.01465C0.5 7.19555 0.825384 6.41001 1.40457 5.83082L6.13234 1.10305C6.51847 0.716923 7.04216 0.5 7.58823 0.5C8.13429 0.5 8.65799 0.716923 9.04411 1.10305C9.43024 1.48917 9.64716 2.01287 9.64716 2.55893C9.64716 3.105 9.43024 3.62869 9.04411 4.01482L4.3112 8.74259C4.11814 8.93565 3.85629 9.04411 3.58326 9.04411C3.31022 9.04411 3.04838 8.93565 2.85531 8.74259C2.66225 8.54953 2.55379 8.28768 2.55379 8.01465C2.55379 7.74162 2.66225 7.47977 2.85531 7.2867L7.22297 2.92419",
    stroke: "#550F66",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipFillPurple);
export default __webpack_public_path__ + "static/media/clip-fill-purple.321c6c2392d2c9131df422c69468ce9f.svg";
export { ForwardRef as ReactComponent };